import api from './api';

export type AdEntityType = 'campaign' | 'adset' | 'ad';

export interface StatusChangeResult {
  succeeded: { id: string; name: string }[];
  failed: { id: string; name: string; error: string }[];
  refreshed: { id: string; fb_id: string; status?: string; effective_status?: string }[];
}

export const adStatusService = {
  /** Pauses or resumes on the ad platform; resolves even when some of them fail. */
  setStatus: async (
    entityType: AdEntityType, ids: string[], status: 'ACTIVE' | 'PAUSED',
  ): Promise<StatusChangeResult> => {
    const res = await api.post('/ads-manager/status', { entity_type: entityType, ids, status });
    return res.data.data as StatusChangeResult;
  },
};
